<template>
  <a-modal
      v-model:visible="taskShow"
      :bodyStyle="{
      padding: '10px 24px',
    }"
      :footer="null"
      width="650px"
  >
    <div class="moda_cont">
      <a-spin :spinning="taskSpin">
        <a-tabs v-model:activeKey="taskActive" @change="changeActive">
          <a-tab-pane key="1">
            <template #tab>
              <a-badge
                  :count="taskData.statis?.todayNewOrder"
                  :number-style="{
                  height: '15px',
                  lineHeight: '15px',
                }"
                  :offset="[10, -8]"
                  :overflowCount="999"
              >
                今日新单
              </a-badge>
            </template>
          </a-tab-pane>
          <a-tab-pane key="2">
            <template #tab>
              <a-badge
                  :count="taskData.statis?.todayInCount"
                  :number-style="{
                  height: '15px',
                  lineHeight: '15px',
                }"
                  :offset="[10, -8]"
                  :overflowCount="999"
              >
                今日入住
              </a-badge>
            </template>
          </a-tab-pane>
          <a-tab-pane key="3">
            <template #tab>
              <a-badge
                  :count="taskData.statis?.todayOutCount"
                  :number-style="{
                  height: '15px',
                  lineHeight: '15px',
                }"
                  :offset="[10, -8]"
                  :overflowCount="999"
              >
                今日退房
              </a-badge>
            </template>
          </a-tab-pane>
          <a-tab-pane key="4">
            <template #tab>
              <a-badge
                  :count="taskData.statis?.tomorrowInCount"
                  :number-style="{
                  height: '15px',
                  lineHeight: '15px',
                }"
                  :offset="[10, -8]"
                  :overflowCount="999"
              >
                明日入住
              </a-badge>
            </template>
          </a-tab-pane>
          <a-tab-pane key="5">
            <template #tab>
              <a-badge
                  :count="taskData.statis?.tomorrowOutCount"
                  :number-style="{
                  height: '15px',
                  lineHeight: '15px',
                }"
                  :offset="[10, -8]"
                  :overflowCount="999"
              >
                明日退房
              </a-badge>
            </template>
          </a-tab-pane>
        </a-tabs>

        <div class="cont_box">
          <div
              v-for="item in taskData.list"
              :key="item.id"
              class="box_item"
              @click="openOrderDetails(item)"
          >
            <div class="item_head">
              <div class="head_left">
                <div class="left_name">{{ item.order_no }}</div>
                <div class="left_tag">
                  <span v-if="item.type == 1" class="tag">用户录入订单</span>
                  <span v-if="item.type == 2" class="tag">公司录入订单</span>
                  <span v-if="item.type == 3" class="tag">同步订单</span>
                  <span v-if="item.type == 4" class="tag">批量活动订单</span>
                  <span class="tag">{{ item.sname }}</span>
                </div>
              </div>
              <div class="head_right">查看详情</div>
            </div>
            <div class="item_body">
              <div class="body_left">
                <a-image
                    :src="item.image || taskImage"
                    style="height: 80px; width: 100px; object-fit: cover"
                />
              </div>
              <div class="body_right">
                <div class="right_house">
                  <span class="house_name">{{ item.name }}</span>
                </div>
                <div class="right_check">
                  <div class="check_night">
                    {{ item.start_date }} ~ {{ item.end_date }}
                  </div>
                  <div class="check_num">共{{ item.nights }}晚</div>
                </div>
                <!-- <div class="right_date">2022-03-02 至 2022-03-03</div> -->
                <div class="right_person">
                  <div class="person_name">{{ item.tname }}</div>
                  <div class="person_phone">{{ item.tphone }}</div>
                </div>
              </div>
              <div class="body_last">{{ item.status_text }}</div>
            </div>
          </div>
          <div v-if="taskData.list?.length <= 0" class="box_none">
            <a-empty :image="simpleImage"/>
          </div>
        </div>
      </a-spin>
    </div>
  </a-modal>

  <!-- 订单详情 -->
  <order-details
      ref="orderDetails"
      v-model:visible="detShow"
      :orderId="orderId"
      @refreshOrderDetails="getTaskData"
  />
</template>

<script>
import {onMounted, reactive, toRefs, watch} from "vue";
import OrderDetails from "@/components/pms/landlord/OrderDetails/OrderDetails.vue";
import {Empty} from "ant-design-vue";
import dayjs from "dayjs";
// import { MinusCircleOutlined } from "@ant-design/icons-vue";
import {getTaskData} from "@/api/api";
// import { message } from "ant-design-vue";
// import { verifyPrice } from "@/common/validator";

export default {
  components: {
    // MinusCircleOutlined,
    OrderDetails,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["update:visible"],
  setup(props, {emit}) {
    const tasks = reactive({
      active: "1",
      detShow: false,
      orderId: "",
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      taskImage: JSON.parse(sessionStorage.getItem("companyInfo"))?.logo,
      taskSpin: false,
      taskShow: false,
      taskActive: "1",
      taskDate: dayjs().format("YYYY-MM-DD"),
      taskData: "",
      // 切换标签
      changeActive(e) {
        if (e < 4) {
          tasks.active = e;
          tasks.taskDate = dayjs().format("YYYY-MM-DD");
        } else {
          tasks.active = e == 4 ? 2 : 3;
          tasks.taskDate = dayjs().add(1, "day").format("YYYY-MM-DD");
        }
        tasks.getTaskData();
      },

      // 订单详情
      openOrderDetails(item) {
        tasks.orderId = item.id;
        tasks.detShow = true;
      },

      // 获取任务数据
      getTaskData() {
        tasks.taskSpin = true;
        getTaskData({
          start: 0,
          limit: 999,
          table: tasks.active,
          date: tasks.taskDate,
        })
            .then((res) => {
              tasks.taskData = res.data;
            })
            .finally(() => {
              tasks.taskSpin = false;
            });
      },
    });

    watch(
        () => tasks.taskShow,
        (value) => {
          tasks.detShow = false;
          emit("update:visible", value);
        }
    );

    watch(
        () => props.visible,
        (newValue) => {
          tasks.taskShow = newValue;
          if (newValue) {
            tasks.getTaskData();
          }
        }
    );

    onMounted(() => {
    });

    return {
      ...toRefs(tasks),
    };
  },
};
</script>

<style lang="scss" scoped>
// 任务
.moda_cont {
  .cont_box {
    padding: 0;
    height: 600px;
    overflow-y: auto;

    .box_none {
      height: 90%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .box_item {
      background-color: #f7f8fa;
      margin-bottom: 16px;
      border-radius: 6px;

      .item_head {
        padding: 15px 20px;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #f2f2f2;

        .head_left {
          display: flex;

          .left_name {
            margin-right: 10px;
          }

          .left_tag {
            .tag {
              background-color: #e9f3ff;
              color: #0094ff;
              padding: 3px 6px;
              margin: 0 6px;
              border-radius: 3px;
            }
          }
        }

        .head_right {
          color: #0094ff;
          cursor: pointer;
        }
      }

      .item_body {
        padding: 15px 20px;
        display: flex;

        .body_left {
          margin-right: 15px;
        }

        .body_right {
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .right_house {
            .house_name {
              margin-right: 10px;
            }

            .house_sn {
              color: #ccc;
            }
          }

          .right_check {
            display: flex;

            .check_night {
              margin-right: 10px;
            }

            .check_num {
            }
          }

          .right_date {
            color: #ccc;
          }

          .right_person {
            display: flex;

            .person_name {
              margin-right: 10px;
            }

            .person_phone {
            }
          }
        }

        .body_last {
          flex: 1;
          text-align: right;
          color: #dd0054;
          font-weight: bold;
        }
      }

      .item_bom {
        padding: 15px 20px;
        display: flex;

        .bom_price {
          display: flex;

          .price_cell {
            display: flex;
            margin-right: 10px;

            &:last-child {
              margin-right: 20px;
            }

            .cell_title {
              color: #ccc;
              margin-right: 6px;
            }

            .cell_num {
              color: #dd0054;
            }
          }
        }

        .bom_time {
          display: flex;

          .time_title {
            color: #ccc;
            margin-right: 6px;
          }

          .time_num {
          }
        }

        .bom_oper {
          flex: 1;
          display: flex;
          justify-content: flex-end;

          .oper_cell {
            background-color: #0094ff;
            width: 80px;
            text-align: center;
            padding: 3px 0;
            margin: 0 6px;
            color: #ffffff;
            border-radius: 4px;
          }
        }
      }
    }
  }
}
</style>
